import axios from "axios";
import router from "@/router";
import getAuthToken from "@/use/get-auth-token";
import { useToast } from "vue-toastification";
import _head from "lodash/head";

let cachedPrimoLab = null;
// { controller: AbortController, id: string }
let currentEntry = null;
let abortSeq = 0;

export function axiosInstanceWithAbort() {
  
  if (cachedPrimoLab) return { primoLab: cachedPrimoLab };

  const toast = useToast();

  const primoLab = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
  });

  primoLab.interceptors.request.use(
    (config) => {
      const token = getAuthToken();
      if (token) {
        if (!config.headers) config.headers = {};
        config.headers["Authorization"] = `Bearer ${token}`;
      }

      if (config.abort === true) {
        if (currentEntry && typeof currentEntry.controller?.abort === 'function' && !currentEntry.controller.signal?.aborted) {
          currentEntry.controller.abort();
        }
        const controller = new AbortController();
        const id = `ab_${Date.now()}_${++abortSeq}`;
        currentEntry = { controller, id };
        config.signal = controller.signal;
        config.abortId = id;
      }

      return config;
    },
    (error) => Promise.reject(error)
  );

  primoLab.interceptors.response.use(
    (response) => {
      if (response.config?.abort === true) {
        const id = response.config?.abortId;
        if (currentEntry?.id === id) currentEntry = null;
      }
      return response;
    },
    (error) => {
      if (error.config?.abort === true) {
        const id = error.config?.abortId;
        if (currentEntry?.id === id) currentEntry = null;
      }
      if (axios.isCancel(error)) {
        return Promise.reject(error);
      }
      if (error?.request?.status === 401 && error?.request?.statusText === "Unauthorized") {
        router.push({ path: "/login" });
      }

      toast.error(
        _head(error?.response?.data?.errors) ?? "Si è verificato un errore. Contattare il servizio tecnico.",
        {
          position: "top-right",
          timeout: 5000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false,
        }
      );

      return Promise.reject(error);
    }
  );

  cachedPrimoLab = primoLab;

  return { primoLab: cachedPrimoLab };
}


